module.exports = __webpack_public_path__ + "static/img/wut_1c_B.7186e67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wut_1c_B.jpg
// module id = 0VQC
// module chunks = 3